import { MatDateFormats } from '@angular/material/core';

export const DATE_TIME_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'dd/MM/yyyy HH:mm',
  },
  display: {
    dateInput: 'dd/MM/yyyy HH:mm',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy HH:mm',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
